const httpUrl = 'https://huapin.zhuzhux.com/huapin'
//     const httpUrl = 'http://localhost:8081/huapin'

const globalServices = {
    //登录
    login: {
        method: 'post',
        url: `${httpUrl}/system/sysUser/login`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/login',
    },
    // 加这里退出
    logout: {
        method: 'post',
        url: `${httpUrl}/system/sysUser/logout`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/logout',
    },
    // 获取登录信息
    queryResource: {
        method: 'get',
        url: `${httpUrl}/system/sysUser/getLoginUser`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/getLoginUser',
    },
    // 用户管理（账号管理）
    accountList: {
        method: 'get',
        url: `${httpUrl}/system/sysUser/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/getPageList',
    },
    accountAdd: {
        method: 'post',
        url: `${httpUrl}/system/sysUser/add`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/add',
    },
    accountEdit: {
        method: 'post',
        url: `${httpUrl}/system/sysUser/update`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/update',
    },
    accountDel: {
        method: 'get',
        url: `${httpUrl}/system/sysUser/delete`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/delete',
    },
    // 角色管理（账号管理）
    roleList: {
        method: 'get',
        url: `${httpUrl}/system/sysRole/list`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRole/list',
    },
    roleAddEdit: {
        method: 'post',
        url: `${httpUrl}/system/sysRole/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRole/save',
    },
    roleDel: {
        method: 'post',
        url: `${httpUrl}/system/sysRole/removeById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRole/removeById',
    },
    // 全部角色
    roleListAll: {
        method: 'get',
        url: `${httpUrl}/system/sysRole/list`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRole/list',
    },
    fetchPermissionByRoleId: {
        method: 'get',
        url: `${httpUrl}//system/sysRolePermission/getSysPermissionByRoleId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/getSysPermissionByRoleId',
    },

    savePermissionByRole: {
        method: 'post',
        url: `${httpUrl}//system/sysRolePermission/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/save',
    },
    fetchPermission: {
        method: 'get',
        url: `${httpUrl}//system/sysRolePermission/getAll`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/getAll',
    },

    projectList: {
        method: 'get',
        url: `${httpUrl}/api/project/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/getPageList',
    },

    projectAddEdit: {
        method: 'post',
        url: `${httpUrl}/api/project/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/save',
    },

    studentList: {
        method: 'get',
        url: `${httpUrl}/api/studentInfo/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/studentInfo/getPageList',
    },

    studentSave: {
        method: 'post',
        url: `${httpUrl}/api/studentInfo/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/studentInfo/save',
    },

    payPackageList: {
        method: 'get',
        url: `${httpUrl}/api/payPackage/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackage/getPageList',
    },

    payPackageSave: {
        method: 'post',
        url: `${httpUrl}/api/payPackage/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackage/save',
    },


    noticeList: {
        method: 'get',
        url: `${httpUrl}/api/notice/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/notice/getPageList',
    },

    noticeSave: {
        method: 'post',
        url: `${httpUrl}/api/notice/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/notice/save',
    },

    noticeDel: {
        method: 'post',
        url: `${httpUrl}/api/notice/del`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/notice/del',
    },



    deviceList: {
        method: 'get',
        url: `${httpUrl}/api/device/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/getPageList',
    },


    /**
     * 入库
     */

    deviceStockIn: {
        method: 'post',
        url: `${httpUrl}/api/device/stockIn`,
        mockMethod: 'post',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/stockIn',
    },

    /**
     * 出库
     */
    deviceStockOut: {
        method: 'post',

        url: `${httpUrl}/api/device/stockOut`,
        mockMethod: 'post',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/stockOut',
    },

    /**
     * 出入库记录
     */
    getDeviceStockOutRecord: {
        method: 'get',
        url: `${httpUrl}/deviceStockOutRecord/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceStockOutRecord/getPageList',
    },



    deviceSave: {
        method: 'post',
        url: `${httpUrl}/api/device/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/save',
    },


    returnRentCheck: {
        method: 'post',
        url: `${httpUrl}/api/device/returnRentCheck`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/returnRentCheck',
    },




    deviceList: {
        method: 'get',
        url: `${httpUrl}/api/device/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/getPageList',
    },

    operationLogList: {
        method: 'get',
        url: `${httpUrl}/system/sysOperation/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysOperation/getPageList',
    },



    getProjectNodeData: {
        method: 'get',
        url: `${httpUrl}/api/project/getNodeData`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/getNodeData',
    },

    getTreeAreaInfo: {
        method: 'get',
        url: `${httpUrl}/api/projectArea/getTreeAreaInfo`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/getTreeAreaInfo',
    },
    delTreeAreaInfo: {
        method: 'get',
        url: `${httpUrl}/api/projectArea/delTreeAreaInfo`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/delTreeAreaInfo',
    },
    updateTreeAreaInfo: {
        method: 'post',
        url: `${httpUrl}/api/projectArea/updateTreeAreaInfo`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/saveTreeAreaInfo',
    },
    addTreeChildNodesAreaInfo: {
        method: 'post',
        url: `${httpUrl}/api/projectArea/addTreeChildNodesAreaInfo`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/saveTreeAreaInfo',
    },

    getProjectRoomList: {
        method: 'get',
        url: `${httpUrl}/api/projectRoom/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectRoom/getPageList',
    },
    areaInfoImportExcel: {
        method: 'get',
        url: `${httpUrl}/api/projectArea/importExcel`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },
    getOrderDepositList: {
        method: 'get',
        url: `${httpUrl}/api/order/deposit/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/deposit/getPageList',
    },
    getOrderRechargeList: {
        method: 'get',
        url: `${httpUrl}/api/order/recharge/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/recharge/getPageList',
    },
    getOrderRefundRechargeList: {
        method: 'get',
        url: `${httpUrl}/api/order/refund/recharge/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/refund/recharge/getPageList',
    },
    getOrderRefundDepositList: {
        method: 'get',
        url: `${httpUrl}/api/order/refund/deposit/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/refund/deposit/getPageList',
    },

    saveOrderRefundRecharge: {
        method: 'post',
        url: `${httpUrl}/api/order/refund/recharge/sysUserCreateRefund`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/refund/recharge/sysUserCreateRefund',
    },

    allProject: {
        method: 'get',
        url: `${httpUrl}/api/project/allProject`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/allProject',
    },


    studentBatchSettingDiscount: {
        method: 'post',
        url: `${httpUrl}/api/studentInfo/batchSettingDiscount`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/studentInfo/batchSettingDiscount',
    },

    //获取套餐应用页面tree 是否选中的状态
    getPayPackageRoomCheckboxIsSelect: {
        method: 'get',
        url: `${httpUrl}/api/payPackageRoom/getCheckboxIsSelect`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/getCheckboxIsSelect',
    },
    getProjectNodeChecked: {
        method: 'get',
        url: `${httpUrl}/api/payPackageRoom/getProjectNodeChecked`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/getProjectNodeChecked',
    },
    getNodeCheckedList: {
        method: 'get',
        url: `${httpUrl}/api/payPackageRoom/getProjectNodeChecked`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/getProjectNodeChecked',
    },

    getPayPackageNodeCheckedList: {
        method: 'get',
        url: `${httpUrl}/api/payPackageRoom/getNodeCheckedList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/getNodeCheckedList',
    },

    getPayPackageByProjectId: {
        method: 'get',
        url: `${httpUrl}/api/payPackageRoom/getPayPackageByProjectId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/getPayPackageByProjectId',
    },
    //获取添加的套餐列表
    getCanAddPayPackageListByProjectId: {
        method: 'get',
        url: `${httpUrl}/api/payPackageRoom/getCanAddPayPackageListByProjectId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/getCanAddPayPackageListByProjectId',
    },

    //获取添加的套餐列表
    addProjectPayPackage: {
        method: 'post',
        url: `${httpUrl}/api/payPackageRoom/add`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/add',
    },

    //套餐从项目中移除
    delByProjectIdAndPayPackageId: {
        method: 'post',
        url: `${httpUrl}/api/payPackageRoom/delByProjectIdAndPayPackageId`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/delByProjectIdAndPayPackageId',
    },

    //把某个房间从套餐中驱逐
    payPackageEvicted: {
        method: 'post',
        url: `${httpUrl}/api/payPackageEvicted/add`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageEvicted/add',
    },

    //解除驱逐
    delPayPackageEvicted: {
        method: 'post',
        url: `${httpUrl}/api/payPackageEvicted/del`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageEvicted/del',
    },

    //手机号授权 查询类型
    getMobileGrantPermissionType: {
        method: 'get',
        url: `${httpUrl}/api/mobile/grantPermission/getMobileType`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mobile/grantPermission/getMobileType',
    },

    //手机号授权 查询类型
    getAppAdminList: {
        method: 'get',
        url: `${httpUrl}/api/appAdmin/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/appAdmin/getPageList',
    },
    addAppAdmin: {
        method: 'post',
        url: `${httpUrl}/api/appAdmin/add`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/appAdmin/add',
    },
    delAppAdmin: {
        method: 'post',
        url: `${httpUrl}/api/appAdmin/del`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/appAdmin/del',
    },

    //保存手机号与权限
    saveUserRoomPermissions: {
        method: 'post',
        url: `${httpUrl}/api/userRoom/permissions/save`,
        mockMethod: 'post',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userRoom/permissions/save',
    },
    //获取我已经有的权限 的tree  懒加载  为了节省服务器性能
    getUserPermissionsByLevel: {
        method: 'get',
        url: `${httpUrl}/api/userRoom/permissions/getUserPermissionsByLevel`,
        mockMethod: 'get',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userRoom/permissions/getUserPermissionsByLevel',
    },

    delUserPermissionsByLevel: {
        method: 'post',
        url: `${httpUrl}/api/userRoom/permissions/delUserPermissionsByLevel`,
        mockMethod: 'post',

        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userRoom/permissions/delUserPermissionsByLevel',
    },


    getTempGrantPermissionLogList: {
        method: 'get',
        url: `${httpUrl}/api/tempGrantPermissionLog/getPageList`,
        mockMethod: 'get',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tempGrantPermissionLog/getPageList',
    },
    getRoomListByMobileNumberAndProjectId: {
        method: 'get',
        url: `${httpUrl}/api/userRoom/permissions/getRoomListByMobileNumberAndProjectId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userRoom/permissions/getRoomListByMobileNumberAndProjectId',
    },

    delStudentById: {
        method: 'post',
        url: `${httpUrl}/api/studentInfo/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/studentInfo/delById',

    },
    saveRoom: {
        method: 'post',
        url: `${httpUrl}/api/projectRoom/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectRoom/save',
    },
    getStudentListByRoomId: {
        method: 'get',
        url: `${httpUrl}/api/studentInfo/getListByRoomId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/studentInfo/getListByRoomId',
    },
    depositRefundAudit: {
        method: 'post',
        url: `${httpUrl}/api/order/refund/deposit/audit`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/refund/deposit/audit',
    },
    getDeviceOperationLog: {
        method: 'get',
        url: `${httpUrl}/api/deviceOperationLog/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceOperationLog/getPageList',
    },


    saveSysUserProjectRelation: {
        method: 'post',
        url: `${httpUrl}/system/sysUserProjectRelation/save`,
        mockMethod: 'post',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUserProjectRelation/save',
    },
    getSysUserPermissionsByLevel: {
        method: 'get',
        url: `${httpUrl}/system/sysUserProjectRelation/getSysUserPermissionsByLevel`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUserProjectRelation/getSysUserPermissionsByLevel',
    },

    delSysUserPermissionsByLevel: {
        method: 'post',
        url: `${httpUrl}/system/sysUserProjectRelation/delSysUserPermissionsByLevel`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUserProjectRelation/delSysUserPermissionsByLevel',
    },


    delPayPackageById: {
        method: 'post',
        url: `${httpUrl}/api/payPackage/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackage/delById',
    },

    sysRefundDeposit: {
        method: 'post',
        url: `${httpUrl}/api/order/refund/deposit/sysRefund`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/refund/deposit/sysRefund',
    },
    delProjectById: {
        method: 'post',
        url: `${httpUrl}/api/project/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/delById',
    },

    delDeviceById: {
        method: 'post',
        url: `${httpUrl}/api/device/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/delById',
    },

    deviceRentReturn: {
        method: 'post',
        url: `${httpUrl}/api/device/rentReturn`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/delById',
    },



    sysUpdatePassword: {
        method: 'post',
        url: `${httpUrl}/system/sysUser/updatePassword`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/updatePassword',
    },

    getHouqinbaoUserList: {
        method: 'get',
        url: `${httpUrl}/houqinbao/getPageUserInfoList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/houqinbao/getPageUserInfoList',
    },
    getHouqinbaoRoomList: {
        method: 'get',
        url: `${httpUrl}/houqinbao/getPageRoomInfoList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/houqinbao/getPageRoomInfoList',
    },



    getHouqinbaoRoomList: {
        method: 'get',
        url: `${httpUrl}/houqinbao/getPageRoomInfoList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/houqinbao/getPageRoomInfoList',
    },


    getUserSignInList: {
        method: 'get',
        url: `${httpUrl}/api/userSignIn/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userSignIn/getPageList',
    },
    getUserMobileNumberChangeRecord: {
        method: 'get',
        url: `${httpUrl}/api/userMobileNumberChangeRecord/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },




    userSave: {
        method: 'post',
        url: `${httpUrl}/user/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    userList: {
        method: 'post',
        url: `${httpUrl}/user/list`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },


    userMobileNumberChangeRecordDeleteById: {
        method: 'post',
        url: `${httpUrl}/user/deleteById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    userMemberCardSave: {
        method: 'post',
        url: `${httpUrl}/userMemberCard/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    userMemberCardConsume: {
        method: 'post',
        url: `${httpUrl}/userMemberCard/consume`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    userExcelExport: {
        method: 'post',
        url: `${httpUrl}/user/excelExport`,
        mockMethod: 'post',
        responseType: 'blob',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },



    //产品管理


    productSkuSave: {
        method: 'post',
        url: `${httpUrl}/productSku/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },


    //sku 删除
    productSkuDeleteById: {
        method: 'post',
        url: `${httpUrl}/productSku/deleteById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    //产品列表
    productPageList: {
        method: 'post',
        url: `${httpUrl}/product/pageList`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    //产品保存
    productSave: {
        method: 'post',
        url: `${httpUrl}/product/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    //产品删除
    productDeleteById: {
        method: 'post',
        url: `${httpUrl}/product/deleteById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    productDetails: {
        method: 'post',
        url: `${httpUrl}/product/getById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    saveSku: {
        method: 'post',
        url: `${httpUrl}/productSku/save`,
        mockMethod: 'post',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    userSettlement: {
        method: 'post',
        url: `${httpUrl}/user/settlement`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },





    deviceReportRecordList: {
        method: 'get',
        url: `${httpUrl}/deviceReportRecord/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    deviceReturnRentList: {
        method: 'get',
        url: `${httpUrl}/deviceReturnRent/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },



    categoryList: {
        method: 'get',
        url: `${httpUrl}/category/getByParentId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    categorySave: {
        method: 'post',
        url: `${httpUrl}/category/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },



    categoryDeleteById: {
        method: 'post',
        url: `${httpUrl}/category/deleteById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    /**
     * 轮播管理
     */

    bannerList: {
        method: 'get',
        url: `${httpUrl}/banner/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },

    bannerSave: {
        method: 'post',
        url: `${httpUrl}/banner/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    bannerDelById: {
        method: 'post',
        url: `${httpUrl}/banner/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },

    /**
     * 用户收货地址管理
     */

    userAddressList: {
        method: 'get',
        url: `${httpUrl}/userAddress/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },

    userAddressSave: {
        method: 'post',
        url: `${httpUrl}/userAddress/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    userAddressDelById: {
        method: 'post',
        url: `${httpUrl}/userAddress/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },



    /**
     * 经销商管理
     */

    distributorList: {
        method: 'get',
        url: `${httpUrl}/userDistributor/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    distributorSave: {
        method: 'post',
        url: `${httpUrl}/userDistributor/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    distributorReview: {
        method: 'post',
        url: `${httpUrl}/userDistributor/review`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    distributorDelById: {
        method: 'post',
        url: `${httpUrl}/userDistributor/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },






    /**
     * 提现管理
     */
    userWithdrawalList: {
        method: 'get',
        url: `${httpUrl}/userWithdrawal/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    userWithdrawalSave: {
        method: 'post',
        url: `${httpUrl}/userWithdrawal/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    userWithdrawalReview: {
        method: 'post',
        url: `${httpUrl}/userWithdrawal/review`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    userWithdrawalDelById: {
        method: 'post',
        url: `${httpUrl}/userWithdrawal/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    //生产管理
    generateMacidDataList: {
        method: 'post',
        url: `${httpUrl}/generateMacidData/getListPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },





    generateMacidDataImportExcel: {
        method: 'get',
        url: `${httpUrl}/generateMacidData/importExcel`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },


    deviceReportRecordList: {
        method: 'get',
        url: `${httpUrl}/deviceReportRecord/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },


    partOrderList: {
        method: 'post',
        url: `${httpUrl}/partOrder/list`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },


    mpsOrderList: {
        method: 'get',
        url: `${httpUrl}/mpsOrder/getMpsOrderPage`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },


    partOrderExport: {
        method: 'post',
        url: `${httpUrl}/partOrder/excelExport`,
        mockMethod: 'post',
        responseType: 'blob',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    updateOrderList: {
        method: 'post',
        url: `${httpUrl}/partOrder/update`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },


    delOrderList: {
        method: 'post',
        url: `${httpUrl}/partOrder/delById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },



    mpsOperationOrder: {
        method: 'get',
        url: `${httpUrl}/mpsOrder/operationOrder`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },


    /**
     * 九号 错误代码配置API
     */
    jiuhaoErrorCodeList: {
        method: 'post',
        url: `${httpUrl}/jiuhaoErrorCode/pageList`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/jiuhaoErrorCode/pageList',
    },

    jiuhaoErrorCodeSave: {
        method: 'post',
        url: `${httpUrl}/jiuhaoErrorCode/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/jiuhaoErrorCode/save',
    },


    jiuhaoErrorCodeDeleteById: {
        method: 'post',
        url: `${httpUrl}/jiuhaoErrorCode/deleteById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/jiuhaoErrorCode/deleteById',
    },



   /**
     * 九号 产品上报记录
     */
    jiuhaoProductionRecordList: {
        method: 'post',
        url: `${httpUrl}/jiuhaoProductionRecord/pageList`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/jiuhaoProductionRecord/pageList',
    },



    jiuhaoProductionRecordDeleteById: {
        method: 'post',
        url: `${httpUrl}/jiuhaoProductionRecord/deleteById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/jiuhaoProductionRecord/deleteById',
    },


    /**
     * 行车智友操作记录
     */
        bleOperationRecordList: {
        method: 'post',
        url: `${httpUrl}/bleOperationRecord/list`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },
    
    dataStatistics: {
        method: 'post',
        url: `${httpUrl}/dataStatistics/totalStatistics`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },
    



};

export default globalServices;


// WEBPACK FOOTER //
// ./src/services/api.js